import { useContext, createContext } from 'react';

/** Opens the mobile drawer from full-bleed screens, which skip the Topbar menu button. */
export const SidebarToggleContext = createContext(() => {});

export const useSidebarToggle = () => useContext(SidebarToggleContext);
